import type { ReactNode } from 'react';

interface Props {
  title?: ReactNode;          // may contain <em> for the gold italic
  note?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** `.shead` + `.panel`: the card + optional header pair used for charts and tables. */
export function Panel({ title, note, children, className = '' }: Props) {
  return (
    <section className="section">
      {title ? (
        <div className="shead">
          <h2>{title}</h2>
          {note ? <div className="note">{note}</div> : null}
        </div>
      ) : null}
      <div className={`panel ${className}`.trim()}>{children}</div>
    </section>
  );
}
